import { useEffect, useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { formatNumber, Text } from '../../../modules/Dashboard'
import SparklesSolidIcon from '../../icons/SparklesSolidIcon'
import { useProfileQuery } from '../../../core/services/react-query/useProfileQuery'

const WalletBalance = () => {
    const location = useLocation()
    const { data: profileData, refetch } = useProfileQuery()

    const balance = useMemo(() => {
        return profileData?.balance ?? 0
    }, [profileData])

    useEffect(() => {
        if (location.state?.fromPaymentSuccess) {
            refetch()
        }
    }, [location.state, refetch])

    return (
        <div className='bg-gradient-to-br from-[#9810FA] to-[#FF6900] rounded-2xl p-4 mb-5'>
            <div className='flex items-center justify-between gap-3 h-full relative'>
                <div className='flex flex-col gap-2'>
                    <span className='flex items-center gap-1'>
                        <SparklesSolidIcon size={18} color="#FFDF20" />
                        <Text tid="your-balance" className='text-xs rtl:font-bold' />
                    </span>
                    <span className='inline text-2xl rtl:font-bold'>
                        <Text tid="$" className='text-lg' />
                        {formatNumber(balance)}
                    </span>
                </div>
            </div>
        </div>
    )
}

export default WalletBalance
